/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expand_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Expand event text" |
*
* @param {Expand_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const expand_aria_label = /** @type {((inputs?: Expand_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expand_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Elargir le texte de l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignistext erweitern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Espandi il testo dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Развернуть текст события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Expandir el texto del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("展开事件文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテキストを展開")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेक्स्ट का विस्तार करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Expandir texto do evento")
	return /** @type {LocalizedString} */ ("Expand event text")
});